export class ApiEndPointsSettings {

  addFolder = 'api/Core/AddFolder';
  getFolderList = 'api/Core/GetAllFolderss';
  getFoldersList = 'api/Core/GetAllFolders';
  getSubFolderList = 'api/Core/GetAllSubFoldersForFolder';
  getFieldTypeList = 'api/Core/GetAllFieldTypes';
  roleList = 'api/ManageRole/GetRoleList';
  addField = 'api/Core/AddField';
  getAllFields = 'api/Core/GetAllFields';
  deleteField = 'api/Core/DeleteField';
  deleteFolder = 'api/Core/DeleteFolder';
  deactivateField = 'api/Core/ChangeFieldStatus';
  createSubFolder = 'api/Core/AddFolder';
  GetAllMedicationList = 'api/Core/GetAllMedicationList';
  GetAllConditionList ='api/Core/GetAllConditionList';
  getSubFolderFields = 'api/Core/GetAllSubFolderFields';
  getFolderFields = 'api/Core/GetAllFolderFields';
  getFoulderFieldsForTab = 'api/Core/GetAllCustomeFieldsForTab';
  getFieldDetailForTab = 'api/Core/GetFieldDetailForTab';
  updateField = 'api/Core/UpdateField';
  getAllFolderFields = 'api/Core/GetAllFolderFields';
  GetAllFieldsForOpenAI = 'api/Core/GetAllFieldsForOpenAI';
  getAllTagList = 'api/app/GetAllTags';
  ReorderFieldPosition = 'api/Core/FieldReorder';
  addEditGroup = 'api/Core/AddEditGroup';
  deleteGroup = 'api/Core/DeleteGroup';
  editGroup = 'api/Core/EditGroup';
  getAllTypes = 'api/Core/GetAllTypes';
  deleteTypes = 'api/Core/DeleteTypes';
  checkIfTypeExists = 'api/Core/CheckIfTypeExists';
  updateType = 'api/Core/UpdateType';

  getAllTags = 'api/App/GetAllTags';
  deleteTags = 'api/App/DeleteTag';
  DeleteConditionByIDs='api/Core/DeleteConditionByIDs';

DeleteAllergyByIDs = 'api/Core/DeleteAllergyByIDs';
AddUpdateAllergyByID = 'api/Core/AddUpdateAllergy';
GetAllAllergyList = 'api/Core/GetAllAllergyList';


GetAllImmunizationList = 'api/Core/GetAllImmunizationList';
AddUpdateImmunizationByID = 'api/Core/AddUpdateImmunization';
DeleteImmunizationByIDs = 'api/Core/DeleteImmunizationByIDs';


// API Address mapping
GetAllObservationList = 'api/Core/GetAllObservationList';
AddUpdateObservationByID = 'api/Core/AddUpdateObservation';
DeleteObservationByIDs = 'api/Core/DeleteObservationByIDs';


  getAllZipCodeList = 'api/Filter/GetAllZipCode';
  getAllTypeList = 'api/Core/GetAllTypesByFolderID';
  getStateList = 'api/Orgnization/GetStateValues';
  getCityList = 'api/Orgnization/GetCityValues';
  geAllTransactionRolesList = 'api/Contact/GetTransactinalRoles';
  deleteTransactionRoles = 'api/Contact/DeleteTransactinalRole';
  UpdateTransactinalRole = 'api/Contact/AddUpdateTransactinalRole';
  getAllTouchTypeList = 'api/app/GetTouchesTypes';
  GetProjectDocumentsAndParticipantDetailsStep4 = 'api/Project/GetProjectDocumentsAndParticipantDetailsStep4';
  FileManagerItemsWithHierarchy = "api/FileManager/FileManagerItemsWithHierarchy";
  getFileManagerFolderList = "api/FileManager/GetFileManagerFolders";
  moveFileManagerItem = "api/FileManager/MoveFileManagerItem";
  renameFileManagerItem = "api/FileManager/RenameFileManagerItem";
  GetUserList = 'api/ManageUser/GetUserList';
  AddRequestFromCore = 'api/CoreDocument/AddRequest';
  AddRequestFromContact = 'api/ContactDocument/AddRequest';
  AddRequestFromCompany = 'api/CompanyDocument/AddRequest';
  AddRequestFromFileManager = 'api/FileManager/AddRequest';
  GetContactListCoreImplementation = 'api/Contact/GetContactListCoreImplementation';
  GetContactListFileManagerImplementation = 'api/Contact/GetContactListFileManagerImplementation';
  AddRequest = 'api/Fax/AddRequest';
  getFormTemplateCategories = "api/Project/GetFormTemplateCategories";
  getOrganizationFormTemplateGallery = "api/Project/GetOrganizationFormTemplateGallery";
  manageFormTemplateOrganizationCategory = "api/Project/ManageFormTemplateOrganizationCategory";
  ManageFormTemplateCategory = "api/Project/ManageFormTemplateCategory";
  GetDefaultSharingRoleSetting = "api/DefaultsharingRoles/GetDefaultSharingRoleSetting";
  AddEditDefaultsharingRoles = "api/DefaultsharingRoles/AddEditDefaultsharingRoles";
  GetAllTemplatestoManage = "api/DocumentTemplate/GetAllTemplatestoManage";
  getNormalAndSharedContacts = 'api/Contact/GetCoreSelectedContact';
  getNormalAndSharedCompanys = 'api/Company/GetCoreSelectedCompany';
  GetContactSelectedCompany = 'api/Company/GetContactSelectedCompany';
  GetCompanySelectedContact = 'api/Company/GetCompanySelectedContact';
  GetContactSelectedContact = 'api/Contact/GetContactSelectedContact';
  DeleteTemplate = "api/DocumentTemplate/DeleteTemplate";
  SearchFieldName = "api/Core/SearchFieldName";
  SearchFieldForImport="api/Core/SearchFieldForImport";
  AddFieldFolderMappingForExistingField = "api/Core/AddFieldFolderMappingForExistingField";
  getFormFolderList = "api/FormFolder/GetFormFolder";
  GetParentFormFolderHierarchy = "api/FormFolder/GetParentFormFolderHierarchy";
  moveForm = "api/FormFolder/MoveForm";
  GetFieldForImportExport = "api/Core/GetFieldForImportExport";
  ValidateCSV = "api/ValidateCSV";
  ImportTripleCCSV = "api/ImportTripleCCSV";
  ExportCSV = "api/ExportCSV";
  SearchSubjectTemplate = "api/App/SearchSubjectTemplate";
  AddUpdateSubjectMessageTemplate = "api/App/AddUpdateSubjectMessageTemplate";
  GetAllSubjectMessageTemplate = "api/App/GetAllSubjectMessageTemplate";
  GetFormDetailsByFormID = 'api/Project/GetFormDetailsByFormID';
  GetRelationByTaskTemplateID = 'api/Project/GetRelationByTaskTemplateID';
  DeleteSubjectMessageTemplate = "api/App/DeleteSubjectMessageTemplate";
  GetLoginDetails = "api/Orgnization/GetLoginDetails";
  getSharedAccesslRoles = 'api/ManageRole/GetAllRolesToLinkContactCompanyCore';
  getTaskDetailByID = "api/Task/GetTaskDetailByID";
  updateTaskDetail = "api/Task/UpdateTaskDetail";
  searchCore = "api/Core/SearchCore";
  searchContact = "api/Contact/SearchContacts";
  searchCompany = "api/Company/SearchCompanies";
  addTaskStatus = "api/TaskStatus/AddTaskStatus";
  getOfficeTaskStatuses = "api/TaskStatus/GetOfficeTaskStatuses";
  renameTaskStatus = "api/TaskStatus/RenameTaskStatus";
  activateTaskStatus = "api/TaskStatus/ActivateTaskStatus";

  getTaskTemplates = "api/TaskTemplate/GetActiveTaskTemplates";
  getActiveTaskTemplates ="api/TaskTemplate/GetActiveTaskTemplates";// "api/TaskTemplate/GetTaskTemplates";
  renameTaskTemplate = "api/TaskTemplate/RenameTaskTemplate";
  activateTaskTemplate = "api/TaskTemplate/ActivateTaskTemplate";
  getTaskListFolders = "api/TaskList/GetTaskListFolders";
  getTasklistFolderSharedWithMe = "api/TaskList/GetTasklistFolderSharedWithMe";
  associateTaskListFoldertoTaskTemplate = "api/TaskTemplate/AssociateTaskListFoldertoTaskTemplate";
  SendEmailForTaskListURL = "api/TaskList/SendEmailForTaskListURL";
  SendExternalURLEmail = "api/auth/SendExternalURLEmail";
  addHeadertoTaskTemplate = "api/TaskTemplate/AddHeadertoTaskTemplate";
  getImageUploadURL = "api/App/UploadProfilePic";

  getTaskTemplateCategories = "api/TaskTemplate/GetTaskTemplateCategories";

  //getActiveTaskTemplateCategories="api/TaskTemplate/GetActiveTaskTemplateCategories";
  addTaskTemplateCategory = "api/TaskTemplate/AddTaskTemplateCategory";
  renameTaskTemplateCategory = "api/TaskTemplate/RenameTaskTemplateCategory";
  removeTaskTemplateCategories = "api/TaskTemplate/RemoveTaskTemplateCategories";

  removeTaskTemplates = "api/TaskTemplate/RemoveTaskTemplates";
  SetDefaultTaskTemplate = "api/TaskList/SetDefualtTaskTemplate";
  activateTaskCategoryTemplate = "api/TaskTemplate/ActivateTaskCategoryTemplate";

  addThirdPartyApi = "api/ThirdPartyApis/AddThirdPartyApi";
  deleteThirdPartyApi = "api/ThirdPartyApis/DeleteThirdPartyApi";
  getThirdPartyApis = "api/ThirdPartyApis/GetThirdPartyApis";
  addThirdPartyApiEndpoint = "api/ThirdPartyApis/AddThirdPartyApiEndpoint";
  AddOfficeThirdPartyApiEndpoint = "/api/ThirdPartyApis/AddOfficeThirdPartyApiEndpoint";
  updateThirdPartyApiEndpoint = "api/ThirdPartyApis/UpdateThirdPartyApiEndpoint";
  getThirdPartyApiEndpoints = "api/ThirdPartyApis/GetThirdPartyApiEndpoints";
  GetOfficeAssociatedApis = "api/ThirdPartyApis/GetOfficeAssociatedApis";
  getOfficeThirdPartyApiEndpoints = "api/ThirdPartyApis/GetOfficeThirdPartyEndpoints";
  deleteThirdPartyApiEndpoint = "api/ThirdPartyApis/DeleteThirdPartyApiEndpoint";
  deleteOfficeThirdPartyApiEndpoint = "api/ThirdPartyApis/DeleteOfficeThirdPartyApiEndpoint";
  addOfficeThirdPartyApi = "api/ThirdPartyApis/AddOfficeThirdPartyApi";
  getOfficeThirdPartyApi = "api/ThirdPartyApis/GetOfficeThirdPartyApi";

  AddSuperAdminThirdPartyApi = "api/ThirdPartyApis/AddSuperAdminThirdPartyApi";
  GetSuperAdminThirdPartyApi = "api/ThirdPartyApis/GetSuperAdminThirdPartyApi";

  RequestClientAccessPayChex = "api/app/RequestClientAccessPayChex";
  GetFacilities = "api/app/GetFacilities";
  addTask = "api/Task/AddTask";
  // getTaskDetailByID = "api/Task/GetTaskDetailByID";
  getTaskList = "api/Task/GetTasks";
  UpdateTaskStatus = "api/Task/UpdateTaskStatus";
  getSubTasks = "api/Task/GetSubTasks";
  removeSubTasks = "api/Task/RemoveSubTasks";
  removeTasks = "api/Task/RemoveTasks";
  sendManualReminderforTask = "api/Task/SendManualReminderforTask";
  addTasklistFolder = "api/TaskList/AddTasklistFolder";
  // getTaskListFolders= "api/TaskList/GetTaskListFolders";
  addTaskList = "api/TaskList/AddTasklist";
  getTaskLists = "api/TaskList/GetTaskLists";
  renameTasklistFolder = "api/TaskList/RenameTasklistFolder";
  removeTasklistFolder = "api/TaskList/RemoveTasklistFolder";
  renameTasklist = "api/TaskList/RenameTasklist";
  removeTasklist = "api/TaskList/RemoveTasklist";
  getTaskByTaskList = "api/Task/GetTaskByTaskList";
  reorderTaskList = "api/Task/ReorderTasks";
  taskMovetoTaskList = "api/Task/TaskMovetoTaskList";
  taskStatus = "api/TaskStatus/GetTaskStatuses"; //"api/TaskStatus/GetOfficeTaskStatuses"; 
  addTaskTemplate = "api/TaskTemplate/AddTaskTemplate";
  //  getTaskTemplates ="api/TaskTemplate/GetActiveTaskTemplates";// "api/TaskTemplate/GetTaskTemplates";
  getActiveTaskTemplateCategories = "api/TaskTemplate/GetActiveTaskTemplateCategories";
  addCorePlaceholdersWithDocuments = "api/CoreDocument/AddCorePlaceholdersWithDocuments";
  addContactPlaceholdersWithDocuments = "api/ContactDocument/AddContactPlaceholdersWithDocuments";
  addCompanyPlaceholdersWithDocuments = "api/CompanyDocument/AddCompanyPlaceholdersWithDocuments";
  getTaskTemplateEmailLog = "api/TaskList/GetTaskTemplateEmailLog";
  resendTemplateUrltoEmail = "api/TaskList/ResendTemplateUrltoEmail";

  softRemoveTaskTemplateSent = "api/TaskList/SoftRemoveTaskTemplateSent";
  hardRemoveTaskTemplateSent = "api/TaskList/HardRemoveTaskTemplateSent";

  GetResponseFromAI = "api/AIChat/GetResponseFromAI";
  SaveFlowtricesAIMessage = "api/AIChat/SaveFlowtricesAIMessage";
  GetFlowtricesAIMessage = "api/AIChat/GetFlowtricesAIMessage";

  extractDocumentData = "api/CoreDocument/ExtractDocumentData";
  //GetFieldForImportExport = "api/Core/GetFieldForImportExport";
  addFormKeyAsNewFields = "api/Core/AddFormKeyAsNewFields";
  AddFormKeyFieldMapping="api/App/AddFormKeyFieldMapping";
  getSynonyms = "api/Core/GetSynonyms";
  extractDocumentDataFileManager = "api/FileManager/ExtractDocumentData";

  getSingleTaskTemplates="api/TaskTemplate/GetSingleTaskTemplates";
  importTaskFromTemplate="api/TaskTemplate/ImportTaskFromTemplate";
  addSingleTaskTemplate="api/TaskTemplate/AddSingleTaskTemplate";

  AddTaskListToCCCs="api/TaskList/AddTaskListToCCCs";
  AddTasksToCCCs="api/TaskTemplate/AddTasksToCCCs";
  getFormFolderWithFormTemplates = 'api/FormFolder/GetFormFolderWithFormTemplates';
  getFormFolderSharedWithMe = 'api/FormFolder/GetFormFolderSharedWithMe';
  getFormFolderWithFormTemplatesSharedWithMe = 'api/FormFolder/GetFormFolderWithFormTemplatesSharedWithMe';
  createProjectsforMultipleCCC="api/Project/CreateProjectsforMultipleCCC";

  archivedTaskList="api/TaskList/ArchivedTaskList";
  archivedTask ="api/Task/ArchivedTask";
  getArchivedTaskLists="api/TaskList/GetArchivedTaskLists";
  getArchivedSingleTaskLists="api/Task/GetTasks";
  GetTaskGroupsByTaskList="api/Task/GetTaskGroupsByTaskList";

  removeSingleTaskTemplates  = "api/TaskTemplate/RemoveSingleTaskTemplates";
  renameSingleTaskTemplate = "api/TaskTemplate/RenameSingleTaskTemplate";
  activeSingleTaskTemplate = "api/TaskTemplate/ActiveSingleTaskTemplate";
  searchFieldName = "api/Core/SearchFieldName";
  getOffices = "api/Orgnization/GetOffices";
  move3CtoAnotherOffice="api/Core/Move3CtoAnotherOffice";
  getCoreListing = "api/Core/GetCores";
  getContactListing = "api/Contact/GetContacts";
  getCompanyListing = 'api/Company/GetCompanies';
  updateCoreFieldColumn = 'api/CustomizedGridComponent/UpdateUserGridCustomizationSetting';
  getStatusesByTouchType="api/CoreTouch/GetStatusesByTouchType";
  getTouchTypeAndStatusess="api/CoreTouch/GetTouchTypeAndStatuses";
  removeTouchStatus  = "api/CoreTouch/RemoveTouchStatus";
  getOCRTemplateCategories="api/OCRTemplate/GetOCRTemplateCategories";
  renameOCRTemplateCategory="api/OCRTemplate/RenameOCRTemplateCategory";
  activateOCRCategoryTemplate="api/OCRTemplate/ActivateOCRCategoryTemplate";
  removeOCRTemplateCategories="api/OCRTemplate/RemoveOCRTemplateCategories";
  GetOCRTemplates="api/OCRTemplate/GetOCRTemplates";
  renameOCRTemplate="api/OCRTemplate/RenameOCRTemplate";
  activateOCRTemplate="api/OCRTemplate/ActivateOCRTemplate";
  GetNTAJsonFromBlob="api/FileManager/GetNTAJsonFromBlob";
  UpdateNTAJsonInBlob="api/FileManager/UpdateNTAJsonInBlob";

  AddUpdateSystemPrompts="api/NLPTemplate/AddUpdateSystemPrompts";
  DeleteSystemPrompt="api/NLPTemplate/DeleteSystemPrompt";
  GetSystemPromptByID="api/NLPTemplate/GetSystemPromptByID";
  GetAllSystemPrompt="api/NLPTemplate/GetAllSystemPrompt";

  removeOCRTemplates="api/OCRTemplate/RemoveOCRTemplates";

  updateFieldDefaultSynonyms="api/OCRTemplate/UpdateFieldDefaultSynonyms";
  updateFieldSynonyms="api/OCRTemplate/UpdateFieldSynonyms";

  addEditEmailTemplate = "api/EmailTemplate/AddEditEmailTemplate";
  getAllEmailTemplates = "api/EmailTemplate/GetAllEmailTemplates";
  getEmailTemplateDetail = "api/EmailTemplate/GetEmailTemplateDetail";
  deleteEmailTemplate = "api/EmailTemplate/DeleteEmailTemplate";
  getOfficeMailConfigration="api/Orgnization/GetOfficeMailConfigration";
  getActivityEMails = "api/CoreTouch/GetActivityEMails";
  removeActivityEmail="api/CoreTouch/RemoveActivityEmail";  
  getNLPTemplateCategories="api/NLPTemplate/GetNLPTemplateCategories";
  renameNLPTemplateCategory="api/NLPTemplate/RenameNLPTemplateCategory";
  activateNLPCategoryTemplate="api/NLPTemplate/ActivateNLPCategoryTemplate";
  removeNLPTemplateCategories="api/NLPTemplate/RemoveNLPTemplateCategories";
  addNLPTemplate="api/NLPTemplate/AddNLPTemplate";
  getNLPTemplates="api/NLPTemplate/GetNLPTemplates";
  getNLPQueries="api/NLPTemplate/GetNLPQueries";
  renameNLPTemplate="api/NLPTemplate/RenameNLPTemplate";
  activateNLPTemplate="api/NLPTemplate/ActivateNLPTemplate";
  removeNLPTemplates="api/NLPTemplate/RemoveNLPTemplates";
  sendFilemanagerDocuments = "api/FileManager/SendFilemanagerDocuments";
  get3CBroadcastMessages = "api/Core/Get3CBroadcastMessages";
  resentBroadcastMessage="api/Core/ResentBroadcastMessage";
  GetAllCoreCarePeriods="api/Core/GetAllCoreCarePeriods";
  AddCarePeriodPCC="api/Core/AddCarePeriodPCC";
  GetMedicationByID="api/Core/GetMedicationByID";
  UpdateMedicationByID="api/Core/UpdateMedicationByID";
  AddUpdateConditionID="api/Core/AddUpdateCondition";
  AddMedicationPCC="api/Core/AddMedicationPCC";
  addFormReportFolder="api/FormFolder/AddFormReportFolder";
  getFormReportFolders="api/FormFolder/GetFormReportFolders";
  removeFormReportFolder="api/FormFolder/RemoveFormReportFolder";
  renameFormReportFolder="api/FormFolder/RenameFormReportFolder";
  addFormReportFolderMapping="api/FormFolder/AddFormReportFolderMapping";
  removeFormReportFolderMapping="api/FormFolder/RemoveFormReportFolderMapping";
  getFormReportFolderMappings="api/FormFolder/GetFormReportFolderMappings";
  activateFormReportFolder="api/FormFolder/ActivateFormReportFolder";
  activateFormReportFolderMapping="api/FormFolder/ActivateFormReportFolderMapping";
  getFormReportFolderMappingsFor3C="api/FormFolder/GetFormReportFolderMappingsFor3C";
  reorder3CFormFolders="api/FormFolder/Reorder3CFormFolders";
  reorder3CForms="api/FormFolder/Reorder3CForms";
  getWebFormReportFor3C="api/FormFolder/GetWebFormReportFor3C";
  updateFormFolderMapping="api/FormFolder/UpdateFormFolderMapping";
  getStatusesByCustomInfoType="api/CustomInfo/GetStatusesByCustomInfoType";
  getCustomInfoTypes="api/CustomInfo/GetCustomInfoTypes";
  getAllCustomInfos="api/CustomInfo/GetAllCustomInfos";
  deleteCustomInfo="api/CustomInfo/DeleteCustomInfo";
  getCustomInfoTypeAndStatuses="api/CustomInfo/getCustomInfoTypeAndStatuses";
  removeCustomInfoStatus="api/CustomInfo/RemoveCustomInfoStatus";
  downloadFilesInZip="api/Core/DownloadFilesInZip";
  getAttachment = 'api/App/DownloadDocument';
  UploadDocumenttoPCC = 'api/CoreDocument/UploadDocumentPCC';
  addDocumentFileManagerTo3C="api/FileManager/AddDocumentFileManagerTo3C";
  getCoreUserDetails = 'api/Core/GetCoreDetail';
  getOCRTemplates = "api/OCRTemplate/GetOCRTemplates";
  getAIAutomationTemplates="api/AIAutomation/GetAIAutomationTemplates";
  addAIAutomationTemplate="api/AIAutomation/AddAIAutomationTemplate";
  GetSharedWithMeFileManager = "api/FileManager/GetSharedWithMeFileManager";
  GetSharedWithMeFileManagerWithHierarchy = "api/FileManager/GetSharedWithMeFileManagerWithHierarchy";
  ExtractTextForFileManagerListProcessIcon = "api/FileManager/ExtractTextForFileManagerListProcessIcon";
  AddVectorFileID = "api/FileManager/AddVectorFileID";
  removeAutomationTemplate="api/AIAutomation/RemoveAutomationTemplate";
  getAIAutomationProcesses="api/AIAutomation/GetAIAutomationProcesses";
  reRunAutomationForAITool="api/AIAutomation/ReRunAutomationForAITool";
  removeAIAutomationProcess="api/AIAutomation/RemoveAIAutomationProcess";
  CreateProjectFromFormLink = "api/CoreDocument/CreateProjectFromFormLink";
  AddEditProjectGroupRelationParticipant = 'api/Project/AddEditProjectGroupRelationParticipant';
  AddCreateProjectforPlaceholder = "api/CoreDocument/AddCreateProjectforPlaceholder";
  AddProjectInfoAsTemplete = "api/Project/AddProjectInfoAsTemplete";
  AddProjectEventLog = "api/Project/AddProjectEventLog";
  GetGroupList = 'api/Project/GetGroupList';
  resetTaskProject="api/Task/ResetTaskProject";
  removeSignature = "api/PublicUser/RemoveSignature";
  getSignaturesAndInitial = "api/PublicUser/GetSignaturesAndInitials";
  addDefaultSignature = "api/PublicUser/ChangeDefaultSignature";
  addSignature = "api/PublicUser/AddSignature";
  getTypeOfParticipants="api/Project/GetTypeOfParticipant";
  resendTasklistURL ="api/TaskList/ResendTasklistURL";
  addEditTaskGroup= "api/TaskList/AddEditTaskGroup";
  getDashboardFolderTasklists="api/TaskList/GetDashboardFolderTasklists";
  aIAutomationRunManuallyForFile="api/AIAutomation/AIAutomationRunManuallyForFile";
  makeTaskRequired = "api/Task/MakeTaskRequired";
  reorderTaskGroup="api/Task/ReorderTaskGroup";
  removeTaskGroup= "api/TaskList/RemoveTaskGroup";
  importSelectedFieldsForOtherOffices="api/Orgnization/ImportSelectedFieldsForOtherOffices";
  setDefualtDocumentTemplate="api/DocumentTemplate/SetDefualtDocumentTemplate";
  renameDocumentTemplate="api/DocumentTemplate/RenameDocumentTemplate";
  reorderDocumentTemplate="api/DocumentTemplate/ReorderDocumentTemplate";

  AddPreferences="api/Auth/AddPreferences";
  getDashboardProcessStages="api/Dashboard/GetDashboardProcessStages";
  updateImportantCore="api/Dashboard/updateImportantCore";
  getAllActiveStages="api/Dashboard/GetAllActiveStages";
  addProcessStage="api/Dashboard/AddProcessStage";
  setProcessStageforTaskTemplate="api/TaskTemplate/SetProcessStageforTaskTemplate";
  setProcessStagetoDocumentFolderTemplate="api/DocumentTemplate/SetProcessStagetoDocumentFolderTemplate";
  getDashboardProcessStagesforManage="api/Dashboard/GetDashboardProcessStagesforManage";
  renameDashboardProcessStages="api/Dashboard/RenameDashboardProcessStages";
  removeDashboardProcessStages="api/Dashboard/RemoveDashboardProcessStages";
  changeActiveStatusforProcessStages="api/Dashboard/ChangeActiveStatusforProcessStages";
  updateShowOnDashboard="api/Dashboard/updateShowOnDashboard";
  reorderProcessStages="api/Dashboard/ReorderProcessStages";
  setDefaultProcessStage="api/Dashboard/setDefaultProcessStage";
  getPDPMStages="api/PDPM/GetPDPMStages";
  getAllNTASummaryList = "api/Core/GetAllNTASummaryList/GetAllNTASummaryList";//"api/Core/GetAllNTASummaryList";
  addUpdateNTASummary ="api/Core/AddUpdateNTASummary";
  deleteNTASummary="api/Core/DeleteNTASummaryByIDs";
  CalculateAndReassignNtaValues="api/Core/CalculateAndReassignNtaValues";
  getMDSNTADocuments="api/Core/GetMDSNTADocuments";
  removeCorefromMedicalCategory="api/PDPM/RemoveCorefromMedicalCategory";
  GetAllCoreDocumentPlaceholders = "api/CoreDocument/GetAllCoreDocumentPlaceholders";
  attachCoreItemForPlaceholder = "api/CoreDocument/AttachCoreItemForPlaceholder";
  AddCoreItemForPlaceholder = 'api/CoreDocument/AddCoreItemForPlaceholder';
}
